import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '@/features/auth';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/login')({
  validateSearch: z.object({ redirect: zSearchText() }),
  component: function Login() {
    const { redirect } = Route.useSearch();
    return <LoginPage redirect={redirect} />;
  },
});
